(function(){
  var root=document.querySelector('[data-pb-pab-root]'); if(!root)return;
  var qs=function(s,c){return (c||root).querySelector(s)}, qsa=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s))};

  var main=qs('#pb-pab-main-image');
  qsa('[data-pb-pab-gallery-src]').forEach(function(btn){
    btn.addEventListener('click',function(){
      qsa('[data-pb-pab-gallery-src]').forEach(function(x){x.classList.remove('is-active')});
      btn.classList.add('is-active');
      main.src=btn.dataset.pbPabGallerySrc;
      main.alt=btn.dataset.pbPabGalleryAlt||'';
    });
  });

  var select=qs('#pb-pab-variant-select'), price=qs('#pb-pab-price'), compare=qs('#pb-pab-compare'), atc=qs('#pb-pab-atc'), finalPrice=qs('#pb-pab-final-price');
  function syncVariant(id){
    var opt=qsa('option',select).filter(function(o){return String(o.value)===String(id)})[0]; if(!opt)return;
    select.value=id;
    price.textContent=opt.dataset.price;
    if(finalPrice)finalPrice.textContent=opt.dataset.price;
    if(opt.dataset.compare){compare.textContent=opt.dataset.compare;compare.classList.remove('is-hidden')}else{compare.textContent='';compare.classList.add('is-hidden')}
    var available=opt.dataset.available==='true';
    atc.disabled=!available;
    atc.textContent=available?'Add to Cart':'Sold Out';
    qsa('[data-pb-pab-variant-id]').forEach(function(b){
      var active=String(b.dataset.pbPabVariantId)===String(id);
      b.classList.toggle('is-active',active);
      b.setAttribute('aria-pressed',String(active));
    });
    var stickySize=qs('[data-pb-pab-sticky-size]'),stickyPrice=qs('[data-pb-pab-sticky-price]');
    if(stickySize)stickySize.textContent=opt.dataset.title;
    if(stickyPrice)stickyPrice.textContent=opt.dataset.price;
    var affirm=qs('.affirm-as-low-as');
    if(affirm){affirm.setAttribute('data-amount',opt.dataset.priceCents||'');if(window.affirm&&affirm.ui&&affirm.ui.refresh)affirm.ui.refresh()}
  }
  qsa('[data-pb-pab-variant-id]').forEach(function(b){b.addEventListener('click',function(){syncVariant(b.dataset.pbPabVariantId)})});

  var qty=qs('.pb-pab__qty input');
  qs('[data-pb-pab-qty-minus]').addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1)});
  qs('[data-pb-pab-qty-plus]').addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+1});

  var states={
    zg:['zg','Zero Gravity','A balanced elevated preset for comfortable reclining.'],
    tv:['tv','TV','Raise the upper body for reading, streaming or relaxing.'],
    antisnore:['antisnore','Anti-Snore','A gentle head-elevated preset for nighttime comfort.'],
    flat:['flat','Flat','Return the base to a completely flat sleeping surface.']
  };
  var pi=qs('#pb-pab-position-image'),pt=qs('#pb-pab-position-title'),pc=qs('#pb-pab-position-copy');
  qsa('[data-pb-pab-position]').forEach(function(b){
    b.addEventListener('click',function(){
      qsa('[data-pb-pab-position]').forEach(function(x){x.classList.remove('is-active')});
      b.classList.add('is-active');
      var s=states[b.dataset.pbPabPosition];
      pi.src=window.pbPabAssetUrls[s[0]];
      pt.textContent=s[1];pc.textContent=s[2];
    });
  });

  var splitPhoto=qs('[data-pb-pab-split-photo]');
  qsa('[data-pb-pab-split]').forEach(function(b){
    b.addEventListener('click',function(){
      qsa('[data-pb-pab-split]').forEach(function(x){x.classList.remove('is-active')});
      b.classList.add('is-active');
      splitPhoto.classList.toggle('is-flipped',b.dataset.pbPabSplit==='left');
    });
  });

  qsa('.pb-pab__faq-list details').forEach(function(d){
    d.addEventListener('toggle',function(){var s=d.querySelector('summary span');if(s)s.textContent=d.open?'−':'+'});
  });

  var lb=qs('[data-pb-pab-lightbox]'),lbi=qs('[data-pb-pab-lightbox-image]');
  function openLB(){lbi.src=main.src;lbi.alt=main.alt;lb.hidden=false;document.body.style.overflow='hidden'}
  function closeLB(){lb.hidden=true;document.body.style.overflow=''}
  qs('[data-pb-pab-lightbox-open]').addEventListener('click',openLB);
  qs('[data-pb-pab-lightbox-close]').addEventListener('click',closeLB);
  lb.addEventListener('click',function(e){if(e.target===lb)closeLB()});

  var modal=qs('[data-pb-pab-size-guide-modal]'),openM=qs('[data-pb-pab-size-guide-open]'),closeM=qs('[data-pb-pab-size-guide-close]'),lastFocus;
  function openModal(){lastFocus=document.activeElement;modal.hidden=false;modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';closeM.focus()}
  function closeModal(){modal.hidden=true;modal.setAttribute('aria-hidden','true');document.body.style.overflow='';if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  openM.addEventListener('click',openModal);closeM.addEventListener('click',closeModal);
  modal.addEventListener('click',function(e){if(e.target===modal)closeModal()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){if(!lb.hidden)closeLB();if(!modal.hidden)closeModal()}});

  var form=qs('#pb-pab-add-to-cart-form'),finalAtc=qs('[data-pb-pab-final-atc]'),mobileAtc=qs('[data-pb-pab-mobile-atc]');
  function submitReal(){if(form.requestSubmit)form.requestSubmit(atc);else atc.click()}
  if(finalAtc)finalAtc.addEventListener('click',submitReal);
  if(mobileAtc)mobileAtc.addEventListener('click',submitReal);

  var sticky=qs('[data-pb-pab-mobile-sticky]');
  if(sticky&&window.IntersectionObserver){
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){sticky.classList.toggle('is-visible',!e.isIntersecting)})},{threshold:.1});
    io.observe(atc);
  }
})();